import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Title, TitleUpsert } from '../../_objects/title';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root'
})
export class TitleOnlineService extends HttpService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  // TL01 /api/v1/titles
  getTitles(): Observable<Title> {
    const endpoint = super.getEndpoint('titles');

    return this.http.get<Title>(endpoint,
      {
        withCredentials: super.getWithCredentialsOption()
      });
  }

  // TL02 /api/tenant/v1/{tenantId}/titles
  upsertTitle(titleUpsert: TitleUpsert): Observable<Title> {
    const endpoint = super.getEndpoint('titles');

    return this.http.put<Title>(
      endpoint,
      titleUpsert,
      { withCredentials: super.getWithCredentialsOption() }
    );
  }
}
